import { Token } from '@/enums/token'
import { useConfig } from '@/composables/game/config'

const { config } = useConfig()

export function getLevelAssetUrl(level: number) {
  return new URL(`/src/assets/images/levels/${level > config.value.game.levels.length ? config.value.game.levels.length : level}.webp`, import.meta.url).href
}

export function getTokenAssetUrl(tokenSlug: string) {
  return new URL(`/src/assets/images/tokens/${tokenSlug}.png`, import.meta.url).href
}

export const tokenSlugMap: Record<Token, string> = {
  [Token.Layer1]: 'layer-1',
  [Token.Layer2]: 'layer-2',
  [Token.AI]: 'ai',
  [Token.DeFi]: 'defi',
  [Token.DePin]: 'depin',
  [Token.GameFi]: 'gamefi',
  [Token.Memecoin]: 'memecoin',
  [Token.NFT]: 'nft',
  [Token.RWA]: 'rwa',
  [Token.Metaverse]: 'metaverse',
  [Token.SocialTokens]: 'social-tokens',
  [Token.Restaking]: 'restaking',
  [Token.Oracles]: 'oracles',
  [Token.DataStorage]: 'data-storage',
}
